import { useState } from "react"
import useProducts from "../../../hooks/useProducts"


export default function ProductsAutoFill({ searchQuery, onChosenProduct}) {
  const [query, setQuery ] = useState()
  const { products } = useProducts(searchQuery)


  const handleChosenProduct = (product) => {
    onChosenProduct(product)
    setQuery(product.name)
  }


  if(query === searchQuery) return null

  return (
     <div className="shadow-lg" style={{ position: "absolute", overflow: "hidden", borderRadius: "0.5rem", width: "468.79px", marginTop: "85px", zIndex: 2}}>
      <ul className="list-group">
        {products.map((product) => (
          <li
            key={product.id}
            className="list-group-item list-group-item-action cursor-pointer fw-bold"
            style={{ opacity: 100 }}
            onClick={(e) => {
              e.stopPropagation()
              handleChosenProduct(product)}
            }
          >
            <span>{product.name}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
